import { client } from '@/libs/openApi'
import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'

export const getLocations = async () => {
	const { language } = useAppConfigStore.getState()

	const { data } = await client.GET('/ibe/v3/locations', {
		params: {
			query: { language },
		},
	})

	// console.log('locations', data)
	return data
}
